import { c as _c } from "react/compiler-runtime";
import type { EntityStatus, VaultKind } from '@onefootprint/request-types/dashboard';
import { Button, Dropdown, useShortcut } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type ManualReviewTriggerProps = {
  kind: VaultKind;
  status: EntityStatus;
  onSelect: (reviewStatus: ReviewStatus) => void;
  disabled?: boolean;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  size?: 'compact' | 'default';
};
enum ReviewStatus {
  pass = 'pass',
  fail = 'fail',
}
const SHORTCUTS: Record<ReviewStatus, string[]> = {
  [ReviewStatus.pass]: ['Control', 'p'],
  [ReviewStatus.fail]: ['Control', 'f']
};
const ManualReviewTrigger = t0 => {
  const $ = _c(81);
  const {
    kind,
    status,
    onSelect,
    disabled,
    onOpenChange,
    open,
    size: t1
  } = t0;
  const size = t1 === undefined ? "compact" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "manualReview"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  let t3;
  if ($[1] !== disabled || $[2] !== onSelect) {
    t3 = () => !disabled && onSelect(ReviewStatus.pass);
    $[1] = disabled;
    $[2] = onSelect;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== disabled || $[5] !== t3) {
    t4 = {
      keys: SHORTCUTS[ReviewStatus.pass],
      onShortcut: t3,
      disabled
    };
    $[4] = disabled;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useShortcut(t4);
  let t5;
  if ($[7] !== disabled || $[8] !== onSelect) {
    t5 = () => !disabled && onSelect(ReviewStatus.fail);
    $[7] = disabled;
    $[8] = onSelect;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== disabled || $[11] !== t5) {
    t6 = {
      keys: SHORTCUTS[ReviewStatus.fail],
      onShortcut: t5,
      disabled
    };
    $[10] = disabled;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useShortcut(t6);
  let t7;
  if ($[13] !== onSelect) {
    t7 = () => {
      onSelect(ReviewStatus.pass);
    };
    $[13] = onSelect;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handlePass = t7;
  let t8;
  if ($[15] !== onSelect) {
    t8 = () => {
      onSelect(ReviewStatus.fail);
    };
    $[15] = onSelect;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const handleFail = t8;
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let fail;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t9;
  if ($[17] !== disabled || $[18] !== handleFail || $[19] !== handlePass || $[20] !== kind || $[21] !== onOpenChange || $[22] !== open || $[23] !== size || $[24] !== status || $[25] !== t) {
    const kindText = kind === "person" ? t(_temp) : t(_temp2);
    let t21;
    if ($[44] !== t) {
      t21 = t(_temp3);
      $[44] = t;
      $[45] = t21;
    } else {
      t21 = $[45];
    }
    const pass = t21;
    let t22;
    if ($[46] !== t) {
      t22 = t(_temp4);
      $[46] = t;
      $[47] = t22;
    } else {
      t22 = $[47];
    }
    fail = t22;
    T4 = Dropdown.Root;
    t18 = open;
    t19 = onOpenChange;
    t20 = <Dropdown.Trigger disabled={disabled} asChild={true}><Button size={size} disabled={disabled}>{t(_temp5, {
          kindText
        })}</Button></Dropdown.Trigger>;
    T3 = Dropdown.Portal;
    T2 = Dropdown.Content;
    t15 = "end";
    t16 = 8;
    t17 = "min-w-[220px]";
    T1 = Dropdown.RadioGroup;
    let t23;
    if ($[48] !== pass) {
      t23 = <span className="text-success">{pass}</span>;
      $[48] = pass;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    t14 = <Dropdown.Item onSelect={handlePass} variant="radio" shortcutHint={SHORTCUTS[ReviewStatus.pass]}><div className="flex flex-row gap-1">{status === "pass" ? t(_temp6, {
          kindText
        }) : t(_temp7, {
          kindText
        })}{t23}</div></Dropdown.Item>;
    T0 = Dropdown.Item;
    t11 = handleFail;
    t12 = "radio";
    t13 = SHORTCUTS[ReviewStatus.fail];
    t9 = "flex flex-row gap-1";
    t10 = status === "fail" ? t(_temp8, {
      kindText
    }) : t(_temp9, {
      kindText
    });
    $[17] = disabled;
    $[18] = handleFail;
    $[19] = handlePass;
    $[20] = kind;
    $[21] = onOpenChange;
    $[22] = open;
    $[23] = size;
    $[24] = status;
    $[25] = t;
    $[26] = T0;
    $[27] = T1;
    $[28] = T2;
    $[29] = T3;
    $[30] = T4;
    $[31] = fail;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
    $[43] = t9;
  } else {
    T0 = $[26];
    T1 = $[27];
    T2 = $[28];
    T3 = $[29];
    T4 = $[30];
    fail = $[31];
    t10 = $[32];
    t11 = $[33];
    t12 = $[34];
    t13 = $[35];
    t14 = $[36];
    t15 = $[37];
    t16 = $[38];
    t17 = $[39];
    t18 = $[40];
    t19 = $[41];
    t20 = $[42];
    t9 = $[43];
  }
  let t21;
  if ($[50] !== fail) {
    t21 = <span className="text-error">{fail}</span>;
    $[50] = fail;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t10 || $[53] !== t21 || $[54] !== t9) {
    t22 = <div className={t9}>{t10}{t21}</div>;
    $[52] = t10;
    $[53] = t21;
    $[54] = t9;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== T0 || $[57] !== t11 || $[58] !== t12 || $[59] !== t13 || $[60] !== t22) {
    t23 = <T0 onSelect={t11} variant={t12} shortcutHint={t13}>{t22}</T0>;
    $[56] = T0;
    $[57] = t11;
    $[58] = t12;
    $[59] = t13;
    $[60] = t22;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== T1 || $[63] !== t14 || $[64] !== t23) {
    t24 = <T1>{t14}{t23}</T1>;
    $[62] = T1;
    $[63] = t14;
    $[64] = t23;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== T2 || $[67] !== t15 || $[68] !== t16 || $[69] !== t17 || $[70] !== t24) {
    t25 = <T2 align={t15} sideOffset={t16} className={t17}>{t24}</T2>;
    $[66] = T2;
    $[67] = t15;
    $[68] = t16;
    $[69] = t17;
    $[70] = t24;
    $[71] = t25;
  } else {
    t25 = $[71];
  }
  let t26;
  if ($[72] !== T3 || $[73] !== t25) {
    t26 = <T3>{t25}</T3>;
    $[72] = T3;
    $[73] = t25;
    $[74] = t26;
  } else {
    t26 = $[74];
  }
  let t27;
  if ($[75] !== T4 || $[76] !== t18 || $[77] !== t19 || $[78] !== t20 || $[79] !== t26) {
    t27 = <T4 open={t18} onOpenChange={t19}>{t20}{t26}</T4>;
    $[75] = T4;
    $[76] = t18;
    $[77] = t19;
    $[78] = t20;
    $[79] = t26;
    $[80] = t27;
  } else {
    t27 = $[80];
  }
  return t27;
};
export default ManualReviewTrigger;
function _temp($) {
  return $.kind.user;
}
function _temp2($_0) {
  return $_0.kind.business;
}
function _temp3($_1) {
  return $_1.status[ReviewStatus.pass];
}
function _temp4($_2) {
  return $_2.status[ReviewStatus.fail];
}
function _temp5($_3) {
  return $_3.button.review;
}
function _temp6($_4) {
  return $_4.dropdown.keepAs;
}
function _temp7($_5) {
  return $_5.dropdown.markAs;
}
function _temp8($_6) {
  return $_6.dropdown.keepAs;
}
function _temp9($_7) {
  return $_7.dropdown.markAs;
}